// extracted by mini-css-extract-plugin
export default {"wrapper":"k3-z","play":"l3-z"};